export declare type ProductAvailabilityType = (typeof ProductAvailability)[keyof typeof ProductAvailability];

export declare const ProductAvailability: {
  readonly available: 'available';
  readonly outOfStock: 'outOfStock';
  readonly notDeliverable: 'notDeliverable';
  readonly unavailable: 'unavailable';
  readonly notEligible: 'notEligible';
};

export function getIdFromGraphId(graphId: unknown): string | null {
  if (typeof graphId === 'string') {
    const regexToGetId = new RegExp(/([0-9]+)/, 'g');
    const regexToGetIdEx = regexToGetId.exec(graphId);
    const id = regexToGetIdEx?.length ? regexToGetIdEx[0] : null;
    return id;
  } else {
    return null;
  }
}

export enum RecommendationType {
  PERSONALIZED = 'PERSONALIZED',
  CUSTOM = 'CUSTOM'
}

export const getBasketRecommendationTitle = (typeOfRecommendation: string) => {
  switch (typeOfRecommendation) {
    case RecommendationType.CUSTOM:
      return 'recommendations.customListTitle';
    case RecommendationType.PERSONALIZED:
      return 'recommendations.personalizedListTitle';
    default:
      return 'recommendations.customListFor3PTitle';
  }
};
